import CONSTANTS from "../../utils/constants"
import { removeCookies, setCookie } from "../../utils/identity-utils"
import { setUserAuthenticated, userLogOutAction } from "../user/user-action"

export function login(jwt: string) {
  setCookie(CONSTANTS.USER_TOKEN_KEY, jwt)
  return async (dispatch): Promise<void> => {
    dispatch(setUserAuthenticated(true))
  }
}

export function logout(userInactivelyLoggedOut: boolean = false) {
  removeCookies()
  return async (dispatch): Promise<void> => {
    dispatch(userLogOutAction(true, userInactivelyLoggedOut))
  }
}
